export const jobTabs = [
  { label: "Overview", slug: "" },
  { label: "Resources", slug: "resources" },
  {
    label: "Settings",
    slug: "settings",
    path: "configuration",
  },
] as const;

export type JobTabItem = (typeof jobTabs)[number]["slug"];
